<template>
  <transition name="fade">
    <div v-show="show" class="v-theme--light message-position">
      <div class="w-100 opacity-75 justify-content-between" :class="className">
        <div class="d-flex flex-column">
          <pre>{{ message }}</pre>
          <div
            v-if="manualLink.length > 0"
            class="d-flex flex-row"
          >
            <pre class="prefix-manual-link">{{ i18n.global.t('pages.common.flashMessages.prefix') }}</pre>
            <a
              class="manual-link"
              :href="manualLink"
              target="_blank"
            >{{ i18n.global.t('pages.common.flashMessages.linkTitle') }}</a>
            <pre class="suffix-manual-link" style="">{{ i18n.global.t('pages.common.flashMessages.suffix') }}</pre>
          </div>
        </div>
        <span class="material-symbols-outlined" @click="hideFlash">
          close
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
import i18n from '@/lang/i18n';

export default {
  setup() {
    return {
      i18n
    };
  },

  props: {
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    fadeOut: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    manualLink: {
      type: String,
      default: ''
    }
  },
  methods: {
    showFlash() {
      if (this.fadeOut) {
        setTimeout(() => {
          this.hideFlash();
        }, 5000);
      }
    },
    hideFlash() {
      this.$emit('hide');
    },
  },
  computed: {
    className() {
      const defaultClass = 'd-inline-flex ';
      switch (this.type) {
        case 'success':
          return defaultClass + 'bg-success';
        case 'info':
          return defaultClass + 'bg-info';
        case 'warn':
          return defaultClass + 'bg-warning';
        case 'error':
          return defaultClass + 'bg-danger';
        default:
      }
      return '';
    },
  },
  watch: {
    show: {
      handler() {
        if (this.show) {
          this.showFlash();
        }
      },
    },
  },
};
</script>

<style scoped>
.fade-enter {
  opacity: 1;
}
.fade-enter-active {
  transition: opacity 0s;
}
.fade-enter-to {
  opacity: 1;
}
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-leave-to {
  opacity: 0;
}
pre {
  margin: 0px;
  padding: 0.5em 1em;
  color: white;
  white-space: pre-wrap;
}
span {
  color: white;
  padding: 0.4em;
}
.message-position {
  margin-top: 48px;
}
@media (min-width: 840px) {
  .message-position {
    margin-left: 56px;
  }
}
.manual-link {
  color: #FFD700;
  text-decoration: none;
  padding: 0em 0em 0.5em 0em;
  font-weight:bold;
}
.prefix-manual-link {
  padding: 0em 0em 0.5em 1em;
}
.suffix-manual-link {
  padding: 0em 0em 0.5em 0em;
}
</style>
